var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.75V0.25H15.5V17.75H10.5ZM0.5 17.75V0.25H5.5V17.75H0.5Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.3a20e6e1bbcb847f2b74d8bd10a01c2a.svg";
export { ForwardRef as ReactComponent };